<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> {{ pageTitle }} </BreadcrumbItem>
    </Breadcrumb>
    <a-alert
        v-if="sectionOne.state==='已驳回' || sectionOne.riskReviewState==='已驳回'"
        :message="mode==='risk-approve'?'风险评估驳回意见':'驳回意见'"
        :description="sectionOne.auditOpinion"
        type="warning"
        show-icon
        style="margin: 10px 10px 0 20px;"
    />
    <div class="page-title-container">
      <div>
        <div class="page-title">项目底层企业信息</div>
        <div><span class="red-asterisk">*</span>为必填项</div>
      </div>
    </div>

    <div class="content-container">
      <div class="container">

        <div class="steps-content">
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">项目名称</span>
            </div>
            <div class="field-content">
              <a-input placeholder="请输入项目名称" v-model="sectionOne.projectName" class="medium-input" />
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">项目公司</span>
            </div>
            <div class="field-content">
              <a-select
                  placeholder="请选择项目公司"
                  v-model="sectionOne.companyId"
                  style="width: 60%">
                <a-select-option v-for="company in companyList" :key="company.companyId" :value="company.companyId">
                  {{ company.companyName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">项目备案容量</span>
            </div>
            <div class="field-content">
              <a-input placeholder="请输入" v-model="sectionOne.projectRecord" suffix="MW" class="medium-input" />
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">所在区域</span>
            </div>
            <div class="field-content">
              <span class="address-label">省市区：</span><a-cascader placeholder="请选择" :options="regionOptions" v-model="sectionOne.regionIds" style="width:240px"  />
              <div class="address-container">
                <span class="address-label">详细地址：</span><a-input placeholder="请输入详细地址" v-model="sectionOne.address" class="medium-input" />
              </div>
              <a-upload
                  name="file"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :action="uploadUrl"
                  @change="onLocationScreenshotUpload"
              >
                <img v-if="locationScreenshot.imageUrl" :src="locationScreenshot.imageUrl" alt="avatar" class="uploaded-img"/>
                <div v-else>
                  <a-icon :type="locationScreenshot.loading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">
                    {{ locationScreenshot.title ? locationScreenshot.title: '点击上传' }}
                  </div>
                </div>
              </a-upload>
              <a-button v-if="locationScreenshot.imageUrl" @click="onLocationHonestScreenshotImg" icon="delete" type="danger" size="small" class="del-btn">删除</a-button>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">底层企业名称</span>
            </div>
            <div class="field-content">
              <a-input placeholder="请输入" v-model="sectionOne.enterpriseName" class="medium-input" />
              <p class="sub-label">主要经营产品或业务</p>
              <a-textarea placeholder="请输入主要经营产品或业务" v-model="sectionOne.businessScope" class="medium-input"></a-textarea>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">底层企业营业执照</span>
            </div>
            <div class="field-content">
              <a-upload
                  name="file"
                  :multiple="false"
                  :action="uploadUrl"
                  :headers="headers"
                  :file-list="license.docList"
                  accept=".pdf,.doc,.docx, image/*"
                  @preview="onPreviewFile"
                  @change="onLicenseUpload"
              >
                <a-button> <a-icon type="upload" /> {{ license.title ? license.title: '点击上传' }} </a-button>
              </a-upload>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">企业处于正常经营状态</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionOne.bizHealth" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionOne.bizHealthRemark" class="remark-input" />
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    list-type="picture-card"
                    class="avatar-uploader"
                    :show-upload-list="false"
                    :action="uploadUrl"
                    @change="onBizHealthScreenshotUpload"
                >
                  <img v-if="bizHealthScreenshot.imageUrl" :src="bizHealthScreenshot.imageUrl" alt="avatar" class="uploaded-img"/>
                  <div v-else>
                    <a-icon :type="bizHealthScreenshot.loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      查询截图
                    </div>
                  </div>
                </a-upload>
                <a-button v-if="bizHealthScreenshot.imageUrl" @click="onDeleteBizHealthScreenshotImg" icon="delete" type="danger" size="small" class="del-btn">删除</a-button>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">企业未曾被列入失信执行人</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionOne.dishonest" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionOne.dishonestRemark" class="remark-input" />
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    list-type="picture-card"
                    class="avatar-uploader"
                    :show-upload-list="false"
                    :action="uploadUrl"
                    @change="onHonestScreenshotUpload"
                >
                  <img v-if="honestScreenshot.imageUrl" :src="honestScreenshot.imageUrl" alt="avatar" class="uploaded-img"/>
                  <div v-else>
                    <a-icon :type="honestScreenshot.loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      {{ honestScreenshot.title ? honestScreenshot.title: '点击上传' }}
                    </div>
                  </div>
                </a-upload>
                <a-button v-if="honestScreenshot.imageUrl" @click="onDeleteHonestScreenshotImg" icon="delete" type="danger" size="small" class="del-btn">删除</a-button>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">企业查询无明显经营风险</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionOne.businessRisk" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionOne.businessRiskRemark" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">需要具备土地证、产权证、或租赁协议（但需要提供房东的土地证、产权证），如无产权证，需附土地证、工程规划许可证、施工许可证、竣工验收证明、消防验收证明</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionOne.landUser" name="radioGroup">
                <a-radio value="业主自持">
                  业主自持
                </a-radio>
                <a-radio value="租赁">
                  租赁(需提供业主方土地证、产权证)
                </a-radio>
              </a-radio-group>
              <div class="dates-container">
                <span class="eff-dates-label">土地证有效期：</span>
                <a-range-picker
                    :placeholder="['开始年月', '截止年月']"
                    format="YYYY-MM"
                    :mode="monthRangeMode"
                    :value="landCertDates"
                    @panelChange="onLandCertDatesChange"
                    style="width: 200px"
                />
                <span class="year-left">剩余年限：{{ landCertExpireYears }} 年</span>
                <a-input placeholder="如时间不够,需加情况说明" v-model="sectionOne.landCertDateRemark" class="remark-input" />
              </div>
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="landCert.docList"
                    @preview="onPreviewFile"
                    @change="onLandCertChange"
                >
                  <a-button> <a-icon type="upload" /> {{ landCert.title ? landCert.title: '点击上传' }} </a-button>
                </a-upload>
              </div>
              <div class="dates-container">
                <span class="eff-dates-label">产权证有效期：</span>
                <a-range-picker
                    :placeholder="['开始年月', '截止年月']"
                    format="YYYY-MM"
                    :mode="monthRangeMode"
                    :value="ownerCertDates"
                    @panelChange="onOwnerCertDatesChange"
                    style="width: 200px"
                />
                <span class="year-left">剩余年限：{{ ownerCertExpireYears }} 年</span>
                <a-input placeholder="如时间不够,需加情况说明" v-model="sectionOne.ownerCertDateRemark" class="remark-input" />
              </div>
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="ownerCert.docList"
                    @preview="onPreviewFile"
                    @change="onOwnerCertChange"
                >
                  <a-button> <a-icon type="upload" /> {{ ownerCert.title ? ownerCert.title: '点击上传' }} </a-button>
                </a-upload>
              </div>
              <div class="dates-container">
                <span class="eff-dates-label">租赁协议有效期：</span>
                <a-range-picker
                    :placeholder="['开始年月', '截止年月']"
                    format="YYYY-MM"
                    :mode="monthRangeMode"
                    :value="leaseAgreementDates"
                    @panelChange="onLeaseAgreeDatesChange"
                    style="width: 200px"
                />
                <span class="year-left">剩余年限：{{ leaseAgreementExpireYears }} 年</span>
                <a-input placeholder="如时间不够,需加情况说明" v-model="sectionOne.leaseAgreeDateRemark" class="remark-input" />
              </div>
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="leaseAgreement.docList"
                    @preview="onPreviewFile"
                    @change="onLeaseAgreementChange"
                >
                  <a-button> <a-icon type="upload" /> {{ leaseAgreement.title ? leaseAgreement.title: '点击上传' }} </a-button>
                </a-upload>
              </div>
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="engineeringPermit.docList"
                    @preview="onPreviewFile"
                    @change="(info) => onDocUpload(info, 'engineeringPermit')"
                >
                  <a-button> <a-icon type="upload" /> {{ engineeringPermit.title ? engineeringPermit.title: '点击上传' }} </a-button>
                </a-upload>
              </div>
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="constructionPermit.docList"
                    @preview="onPreviewFile"
                    @change="(info) => onDocUpload(info, 'constructionPermit')"
                >
                  <a-button> <a-icon type="upload" /> {{ constructionPermit.title ? constructionPermit.title: '点击上传' }} </a-button>
                </a-upload>
              </div>
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="completionCert.docList"
                    @preview="onPreviewFile"
                    @change="(info) => onDocUpload(info, 'completionCert')"
                >
                  <a-button> <a-icon type="upload" /> {{ completionCert.title ? completionCert.title: '点击上传' }} </a-button>
                </a-upload>
              </div>
              <div class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="fireSafetyCert.docList"
                    @preview="onPreviewFile"
                    @change="(info) => onDocUpload(info, 'fireSafetyCert')"
                >
                  <a-button> <a-icon type="upload" /> {{ fireSafetyCert.title ? fireSafetyCert.title: '点击上传' }} </a-button>
                </a-upload>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">房屋产权清晰、无纠纷</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionOne.rightsClear" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionOne.rightsClearRemark" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">自发自用项目企业属性</span>
            </div>
            <div class="field-content">
              <a-select v-model="sectionOne.operatorType" placeholder="请选择" style="width: 160px">
                <a-select-option value="央国企">
                  央国企
                </a-select-option>
                <a-select-option value="上市公司">
                  上市公司
                </a-select-option>
                <a-select-option value="行业龙头企业">
                  行业龙头企业
                </a-select-option>
                <a-select-option value="党政机关">
                  党政机关
                </a-select-option>
                <a-select-option value="5年以上民企">
                  5年以上民企
                </a-select-option>
                <a-select-option value="5年以下民企">
                  5年以下民企
                </a-select-option>
              </a-select>
              <div v-if="sectionOne.operatorType==='5年以下民企'" class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="existenceCert.docList"
                    @preview="onPreviewFile"
                    @change="onExistenceCertUpload"
                >
                  <a-button> <a-icon type="upload" /> {{ existenceCert.title ? existenceCert.title: '点击上传' }} </a-button>
                </a-upload>
              </div>
            </div>
          </div>

        </div>
      </div>

      <DocPreview ref="docPreview" />
    </div>
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {baseURL} from "@/services/HttpService";
import {loadSectionOne, saveSectionOne} from "@/services/SpecService";
import {regionOptions} from "@/geo/region";
import DocPreview from "@/views/DocPreview.vue";
import {loadMyCompanyList} from "@/views/company/CompanyApi";
import moment from 'moment';

export default {
  props: {
    projectId: String,
    mode: String
  },
  emits: ['sectionSaved', 'saveSectionFailed'],
  components: { BreadcrumbItem, Breadcrumb, DocPreview },
  data() {
    return {
      pageTitle: "新增项目",
      current: 0,
      headers: {
        authorization: 'authorization-text',
      },
      uploadUrl: baseURL + "/upload/spec",
      viewUrl: baseURL + "/attachment?fileName=",
      regionOptions,
      license: {
        loading: false,
        docList: [],
        title: "营业执照"
      },
      honestScreenshot: {
        loading: false,
        imageUrl: "",
        title: "查询截图"
      },
      bizHealthScreenshot: {
        loading: false,
        imageUrl: "",
        title: "查询截图"
      },
      locationScreenshot: {
        loading: false,
        imageUrl: "",
        title: "卫星地图位置截图"
      },
      landCert: {
        loading: false,
        docList: [],
        title: "土地证"
      },
      ownerCert: {
        loading: false,
        docList: [],
        title: "产权证"
      },
      leaseAgreement: {
        loading: false,
        docList: [],
        title: "租赁协议"
      },
      engineeringPermit: {
        loading: false,
        docList: [],
        title: "工程规划许可证"
      },
      constructionPermit: {
        loading: false,
        docList: [],
        title: "施工许可证"
      },
      completionCert: {
        loading: false,
        docList: [],
        title: "竣工验收证明"
      },
      fireSafetyCert: {
        loading: false,
        docList: [],
        title: "消防验收证明"
      },
      existenceCert: {
        loading: false,
        docList: [],
        title: "持续性经营证明文件"
      },
      sectionOne: {
        projectName: "",
        companyId: "",
        licenseImgUrl: "",
        enterpriseName: "",
        projectRecord: "",
        riskReviewState: "",
        regionIds:[],
        bizHealth: "",
        bizHealthRemark: "",
        dishonest: "",
        dishonestRemark: "",
        businessRisk: "",
        businessRiskRemark: "",
        landUser: "",
        rightsClear: "",
        rightsClearRemark: "",
        operatorType: "",
        address: "",
        businessScope: "",
        landCertStartYm: "",
        landCertExpireYm: "",
        landCertDateRemark: "",
        ownerCertStartYm: "",
        ownerCertExpireYm: "",
        ownerCertDateRemark: "",
        leaseAgreeStartYm: "",
        leaseAgreeExpireYm: "",
        leaseAgreeDateRemark: "",
      },
      companyList:[],
      monthRangeMode: ["month", "month"],
      landCertDates: [],
      ownerCertDates: [],
      leaseAgreementDates: [],
      landCertExpireYears: 0,
      ownerCertExpireYears: 0,
      leaseAgreementExpireYears: 0,
    };
  },
  created() {
    console.log('projectId', this.projectId);
    if(this.projectId!=='0') {
      this.pageTitle = "编辑表单";
    }
    loadMyCompanyList().then(resp => {
      if (resp.data.code === "SUCCESS") {
        this.companyList = resp.data.data;
      }
    });
  },
  mounted() {
    this.startLoadSectionOne();
  },
  methods: {
    onExistenceCertUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.existenceCert.docList = fileList;
    },
    onDocUpload(info, paramName){
      let fileList = this.changeToAbsImgPath(info);
      this[paramName].docList = fileList;
    },
    onLeaseAgreementChange(info){
      let fileList = this.changeToAbsImgPath(info);
      this.leaseAgreement.docList = fileList;
    },
    onOwnerCertChange(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.ownerCert.docList = fileList;
    },
    onLandCertChange(info){
      let fileList = this.changeToAbsImgPath(info);
      this.landCert.docList = fileList;
    },
    // 正常经营查询截图
    onLocationScreenshotUpload(info){
      if (info.file.status === 'done') {
        let imageUrl = this.viewUrl + info.file.response.data
        this.locationScreenshot.imageUrl = imageUrl;
        this.locationScreenshot.loading = false;
      } else {
        this.locationScreenshot.loading = true;
      }
    },
    onLocationHonestScreenshotImg(){
      this.locationScreenshot.imageUrl = "";
    },
    // 正常经营查询截图
    onBizHealthScreenshotUpload(info){
      if (info.file.status === 'done') {
        let imageUrl = this.viewUrl + info.file.response.data
        this.bizHealthScreenshot.imageUrl = imageUrl;
        this.bizHealthScreenshot.loading = false;
      } else {
        this.bizHealthScreenshot.loading = true;
      }
    },
    onDeleteBizHealthScreenshotImg(){
      this.bizHealthScreenshot.imageUrl = "";
    },
    // 失信查询截图
    onHonestScreenshotUpload(info){
      if (info.file.status === 'done') {
        let imageUrl = this.viewUrl + info.file.response.data
        this.honestScreenshot.imageUrl = imageUrl;
        this.honestScreenshot.loading = false;
      } else {
        this.honestScreenshot.loading = true;
      }
    },
    onDeleteHonestScreenshotImg(){
      this.honestScreenshot.imageUrl = "";
    },
    toggleRemarkInput(radioFieldName, remarkFieldName){
      if(this.sectionOne[radioFieldName] === '符合') {
        this.sectionOne[remarkFieldName] = '';
      }
    },
    startLoadSectionOne(){
      if(this.projectId!=="0") {
        loadSectionOne(this.projectId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            let data = resp.data.data;
            if(data.licenseImgUrl) {
              this.license.imageUrl = this.viewUrl + data.licenseImgUrl;
            }
            if(data.dishonestImageUrl) {
              this.honestScreenshot.imageUrl = this.viewUrl + data.dishonestImageUrl;
            }
            if(data.bizHealthImageUrl) {
              this.bizHealthScreenshot.imageUrl = this.viewUrl + data.bizHealthImageUrl;
            }
            if(data.locationImageUrl) {
              this.locationScreenshot.imageUrl = this.viewUrl + data.locationImageUrl;
            }
            this.sectionOne = data;
            this.buildDocList(data.bizDocList, 'bizDoc');
            this.buildDocList(data.licenseDocList, 'license');
            this.buildDocList(data.landCertDocList, 'landCert');
            this.buildDocList(data.ownerCertDocList, 'ownerCert');
            this.buildDocList(data.engineeringPermitDocList, 'engineeringPermit');
            this.buildDocList(data.constructionPermitDocList, 'constructionPermit');
            this.buildDocList(data.completionCertDocList, 'completionCert');
            this.buildDocList(data.fireSafetyCertDocList, 'fireSafetyCert');
            this.buildDocList(data.leaseAgreementDocList, 'leaseAgreement');
            this.buildDocList(data.existenceCertDocList, 'existenceCert');

            if(data.landCertStartYm && data.landCertExpireYm) {
              this.landCertDates = [moment(data.landCertStartYm, 'YYYY-MM'), moment(data.landCertExpireYm, 'YYYY-MM')];
            }
            if(data.ownerCertStartYm && data.ownerCertExpireYm) {
              this.ownerCertDates = [moment(data.ownerCertStartYm, 'YYYY-MM'), moment(data.ownerCertExpireYm, 'YYYY-MM')];
            }
            if(data.leaseAgreeStartYm && data.leaseAgreeExpireYm) {
              this.leaseAgreementDates = [moment(data.leaseAgreeStartYm, 'YYYY-MM'), moment(data.leaseAgreeExpireYm, 'YYYY-MM')];
            }

          }
        });
      }
    },
    buildDocList(docList, propName) {
      if(docList && docList.length > 0) {
        for (let i = 0; i < docList.length; i++) {
          let doc = docList[i];
          this[propName].docList.push({
            uid: doc.uid,
            name: doc.name,
            status: 'done',
            url: this.viewUrl + doc.url
          });
        }
      }
    },
    // 上传营业执照
    onLicenseUpload(info){
      let fileList = [...info.fileList];

      fileList = fileList.map(file => {
        if (file.response) {
          file.url = this.viewUrl + file.response.data;
        }
        return file;
      });
      this.license.docList = fileList;
    },

    changeToAbsImgPath(info){
      let fileList = [...info.fileList];

      fileList = fileList.map(file => {
        if (file.response) {
          file.url = this.viewUrl + file.response.data;
          console.log('fileUrl', file.url);
        }
        return file;
      });
      return fileList;
    },

    validateSectionOne(isDraft){
      if(isDraft){
        if(this.sectionOne.projectRecord && isNaN(this.sectionOne.projectRecord)) {
          return "项目备案容量必须是数字";
        }
        return "";
      }
      let incompleteMsg = "请填写所有必填信息";
      if(!this.sectionOne.projectName) {
        return incompleteMsg;
      }
      if(this.sectionOne.companyId === "") {
        return "请选择项目公司";
      }
      if(isNaN(this.sectionOne.projectRecord)) {
        return "项目备案容量必须是数字";
      }
      if(!this.sectionOne.regionIds || this.sectionOne.regionIds.length === 0) {
        return "请选择所在区域";
      }
      if(this.sectionOne.enterpriseName === "") {
        return "请输入底层企业名称";
      }
      if(!this.license.docList.length === 0) {
        return "请上传底层企业营业执照";
      }
      if(!this.sectionOne.bizHealth){
        return "请填写企业经营状态";
      }
      if(!this.sectionOne.dishonest){
        return "请填写企业是否曾被列入失信执行人";
      }
      if(!this.honestScreenshot.imageUrl) {
        return "请上传失信执行人查询截图";
      }
      if(!this.bizHealthScreenshot.imageUrl) {
        return "请上传企业正常经营查询截图";
      }
      if(!this.sectionOne.businessRisk){
        return "请填写企业经营风险查询结果";
      }
      if(this.sectionOne.operatorType==='5年以下民企' && this.existenceCert.docList.length === 0) {
        return "请上传持续性经营证明文件";
      }
      let hasOwnerDocument = false;
      if(this.ownerCert.docList.length === 0 ) {
        let hasRequiredDocuments = this.landCert.docList.length > 0
            && this.engineeringPermit.docList.length > 0
            && this.constructionPermit.docList.length > 0
            && this.completionCert.docList.length > 0
            && this.fireSafetyCert.docList.length > 0;
        if(!hasRequiredDocuments) {
          return "如无产权证，需附土地证、工程规划许可证、施工许可证、竣工验收证明、消防验收证明";
        } else {
          hasOwnerDocument = true;
        }
      } else {
        hasOwnerDocument = true;
      }
      if(this.landCert.docList.length === 0 && !hasOwnerDocument) {
        return "土地证或产权证至少上传一项";
      }

      if(this.sectionOne.landUser==='租赁' && this.leaseAgreement.docList.length === 0) {
        return "请上传租赁协议";
      }
      if(!this.sectionOne.landUser){
        return incompleteMsg;
      }
      if(!this.sectionOne.rightsClear){
        return incompleteMsg;
      }
      if(!this.sectionOne.projectRecord) {
        console.log('projectRecord');
        return incompleteMsg;
      }
      return "";
    },
    onSaveDraft(){
      let isDraft = true;
      this.saveAs(isDraft);
    },
    getCompanyId(){
      return this.sectionOne.companyId;
    },
    onSubmit(auditorId) {
      let isDraft = false;
      this.saveAs(isDraft, auditorId);
    },
    saveAs(isDraft, auditorId){
      let validateMsg = this.validateSectionOne(isDraft);
      console.log("validateMsg", ">"+validateMsg+"<");
      if(validateMsg===""){
        if(auditorId===undefined || auditorId === null) {
          auditorId = "";
        }
        let params = {
          ...this.sectionOne,
          projectId: this.projectId,
          licenseDocList: [],
          landCertDocList: [],
          ownerCertDocList: [],
          leaseAgreementDocList: [],
          engineeringPermitDocList: [],
          constructionPermitDocList: [],
          completionCertDocList: [],
          fireSafetyCertDocList: [],
          existenceCertDocList:[],
          state: isDraft ? "未提交":"已提交",
          mode: this.mode,
          auditorId: auditorId
        }
        // 营业执照
        this.prepareDocList(this.license.docList, params, "licenseDocList");
        // 土地证
        this.prepareDocList(this.landCert.docList, params, "landCertDocList");
        // 产权证
        this.prepareDocList(this.ownerCert.docList, params, "ownerCertDocList");
        this.prepareDocList(this.engineeringPermit.docList, params, "engineeringPermitDocList");
        this.prepareDocList(this.constructionPermit.docList, params, "constructionPermitDocList");
        this.prepareDocList(this.completionCert.docList, params, "completionCertDocList");
        this.prepareDocList(this.fireSafetyCert.docList, params, "fireSafetyCertDocList");
        if(this.sectionOne.landUser==='租赁') {
          this.prepareDocList(this.leaseAgreement.docList, params, "leaseAgreementDocList");
        }
        if(this.sectionOne.operatorType==='民企') {
          this.prepareDocList(this.existenceCert.docList, params, "existenceCertDocList");
        }
        if(this.honestScreenshot.imageUrl) {
          params.dishonestImageUrl = this.honestScreenshot.imageUrl.replace(this.viewUrl, '');
        } else {
          params.dishonestImageUrl = "";
        }
        if(this.bizHealthScreenshot.imageUrl) {
          params.bizHealthImageUrl = this.bizHealthScreenshot.imageUrl.replace(this.viewUrl, '');
        } else {
          params.bizHealthImageUrl = "";
        }
        if(this.locationScreenshot.imageUrl) {
          params.locationImageUrl = this.locationScreenshot.imageUrl.replace(this.viewUrl, '');
        } else {
          params.locationImageUrl = "";
        }
        console.log("保存参数", params);
        saveSectionOne(params).then(resp => {
          if (resp.data.code === "SUCCESS") {
            let projectId = resp.data.data;
            this.$emit('sectionSaved', projectId);
          } else {
            this.$message.error("操作失败: " + resp.data.errorMsg);
            this.$emit('saveSectionFailed');
          }
        });
      } else {
        this.$message.error(validateMsg);
        this.$emit('saveSectionFailed');
      }
    },
    prepareDocList(docList, params, propName){
      if(docList.length > 0) {
        for (let i = 0;i< docList.length; i++) {
          let oneDoc = docList[i];
          params[propName].push({
            uid: oneDoc.uid,
            name: oneDoc.name,
            url: oneDoc.url.replace(this.viewUrl, '')
          });
        }
      }
    },
    showSectionTwo(){
      this.$router.push({
        path: "/adm/section-two/" + this.projectId + "/" + this.mode
      });
    },
    // 预览已上传文件
    onPreviewFile(doc){
      this.$refs.docPreview.previewFile(doc);
    },
    onLandCertDatesChange(value){
      this.landCertDates = value;
      if (value.length === 2) {
        this.sectionOne.landCertStartYm = value[0].format('YYYY-MM');
        this.sectionOne.landCertExpireYm = value[1].format('YYYY-MM');
        console.log(this.sectionOne.landCertStartYm + " ~ " + this.sectionOne.landCertExpireYm);

        let endDate = value[1];
        let currentDate = new Date();
        let yearsLeft = (endDate.year() - currentDate.getFullYear()) + (endDate.month() - currentDate.getMonth()) / 12;
        this.landCertExpireYears = Math.floor(yearsLeft);
      } else {
        this.landCertExpireYears = "";
      }
    },
    onOwnerCertDatesChange(value){
      this.ownerCertDates = value;
      if (value.length === 2) {
        this.sectionOne.ownerCertStartYm = value[0].format('YYYY-MM');
        this.sectionOne.ownerCertExpireYm = value[1].format('YYYY-MM');
        console.log(this.sectionOne.ownerCertStartYm + " ~ " + this.sectionOne.ownerCertExpireYm);

        let endDate = value[1];
        let currentDate = new Date();
        let yearsLeft = (endDate.year() - currentDate.getFullYear()) + (endDate.month() - currentDate.getMonth()) / 12;
        this.ownerCertExpireYears = Math.floor(yearsLeft);
      } else {
        this.ownerCertExpireYears = "";
      }
    },
    onLeaseAgreeDatesChange(value) {
      this.leaseAgreementDates = value;
      if (value.length === 2) {
        this.sectionOne.leaseAgreeStartYm = value[0].format('YYYY-MM');
        this.sectionOne.leaseAgreeExpireYm = value[1].format('YYYY-MM');
        console.log(this.sectionOne.leaseAgreeStartYm + " ~ " + this.sectionOne.leaseAgreeExpireYm);

        let endDate = value[1];
        let currentDate = new Date();
        let yearsLeft = (endDate.year() - currentDate.getFullYear()) + (endDate.month() - currentDate.getMonth()) / 12;
        this.leaseAgreementExpireYears = Math.floor(yearsLeft);
      } else {
        this.leaseAgreementExpireYears = "";
      }
    },

  }
}
</script>
<style scoped>
.container {
  width: 100%;
  background-color: white;
  box-sizing: border-box;
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
}
.long-input {
  max-width: 80%;
}
.medium-input {
  max-width: 60%;
}
.remark-input {
  max-width: 30%;
}
.field-container {
  padding-bottom: 12px;
}
.field-label-container {
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.85)
}
.field-label {
  margin-left: 4px;
}
.required-mark {
  color: red;
  margin-right: 2px;
}
.action-container {
  padding-top: 20px;
}
.draft-btn {
  margin-right: 30px;
}
.doc-uploader {
  margin-top: 12px;
}
.year-input {
  width: 100px;
}
.field-input-container {
  padding-top:10px;
  padding-bottom: 10px;
}
.address-container {
  margin-top: 16px;
  margin-bottom: 16px;
}
.address-label {
  display: inline-block;
  width: 70px;
}
.sub-label {
  margin-top: 1em;
  margin-bottom: 4px;
}
.dates-container {
  padding-top: 10px;
}
.year-left {
  margin-left: 10px;
  margin-right: 10px;
  color: #BBBBBB;
}
.eff-dates-label {
  display: inline-block;
  width: 8em;
}
</style>
